export default "__VITE_ASSET__dOndOKf2__"